import { render } from "./Design_Email_Template.vue?vue&type=template&id=8bab0164&scoped=true"
import script from "./Design_Email_Template.vue?vue&type=script&lang=js"
export * from "./Design_Email_Template.vue?vue&type=script&lang=js"

import "./Design_Email_Template.vue?vue&type=style&index=0&id=8bab0164&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bab0164"]])

export default __exports__